import { IEmploymentInfo } from '@shared/integrations/taf-api/v2/models';
import {IEmploymentV2Model} from "@my-pages/features/employment/types/EmploymentV2Model.ts";

export enum employmentType {
    unemployed = 'Arbetslös',
    parentLeave = 'Föräldraledig',
    retired = 'Pensionär',
    student = 'Studerande',
    active = 'Yrkesaktiv',
    hired = 'Anställd',
}

export const isEmployed = (employment: IEmploymentInfo) => {
    return employment && employment.occupationalStatusName === employmentType.active;
};

export const isEmployedV2 = (employment: IEmploymentV2Model) => {
    return employment && employment.employmentType === employmentType.hired && employment.company;
};

export const isUnemployed = (employment: IEmploymentInfo) => {
    return employment && employment.occupationalStatusName === employmentType.unemployed;
};

export const isRetired = (employment: IEmploymentInfo) => {
    return employment && employment.occupationalStatusName === employmentType.retired;
};

export const isOnParentalLeave = (employment: IEmploymentInfo) => {
    return employment && employment.occupationalStatusName === employmentType.parentLeave;
};

export const isStudent = (employment: IEmploymentInfo) => {
    return employment && employment.occupationalStatusName === employmentType.student;
};

export const isOther = (employment: IEmploymentInfo) => {
    return !(isEmployed(employment) || isUnemployed(employment) || isRetired(employment) || isOnParentalLeave(employment) || isStudent(employment));
};
